import React from "react";
import './Title.css';

function Title() {
    return (
        <h1 className="game-title">
            <span className="c-green">T</span>
            <span className="c-blue">I</span>
            <span className="c-yellow">L</span>
            <span className="c-red">E</span>
            <span> </span>
            <span className="c-green">S</span>
            <span className="c-red">P</span>
            <span className="c-yellow">R</span>
            <span className="c-blue">I</span>
            <span className="c-green">N</span>
            <span className="c-blue">T</span>
        </h1>
    );
}

export default Title;